// extracted by mini-css-extract-plugin
module.exports = {"video":"index-module--video--pfXPH","text":"index-module--text--24Z4b","foot":"index-module--foot--34VNa"};